import { render } from "./ChildHighRiskTable.vue?vue&type=template&id=859e316e&scoped=true"
import script from "./ChildHighRiskTable.vue?vue&type=script&lang=js"
export * from "./ChildHighRiskTable.vue?vue&type=script&lang=js"

import "./ChildHighRiskTable.vue?vue&type=style&index=0&id=859e316e&scoped=true&lang=css"
import "./ChildHighRiskTable.vue?vue&type=style&index=1&id=859e316e&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859e316e"]])

export default __exports__